import React, { useState } from 'react';
import { Card, Table, Button, Input, Space, Tag, Typography, Row, Col, Select } from 'antd';
import { SearchOutlined, PlusOutlined, ReloadOutlined, CopyOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Search } = Input;
const { Option } = Select;

interface PackageTemplate {
  key: string;
  id: string;
  templateName: string;
  templateType: string;
  dataAmount: number;
  duration: number;
  price: number;
  status: 'active' | 'inactive';
  createTime: string;
  updateTime: string;
}

const PackageTemplate: React.FC = () => {
  const [loading, setLoading] = useState(false);

  // 模拟数据
  const mockData: PackageTemplate[] = [
    {
      key: '1',
      id: 'TPL001',
      templateName: '基础流量包',
      templateType: '流量包',
      dataAmount: 10,
      duration: 30,
      price: 29.9,
      status: 'active',
      createTime: '2024-01-01',
      updateTime: '2024-01-10',
    },
    {
      key: '2',
      id: 'TPL002',
      templateName: '企业专线',
      templateType: '专线',
      dataAmount: 100,
      duration: 90,
      price: 299.9,
      status: 'active',
      createTime: '2024-01-02',
      updateTime: '2024-01-05',
    },
    {
      key: '3',
      id: 'TPL003',
      templateName: '测试套餐',
      templateType: '测试',
      dataAmount: 1,
      duration: 7,
      price: 9.9,
      status: 'inactive',
      createTime: '2024-01-03',
      updateTime: '2024-01-08',
    },
  ];

  const columns = [
    {
      title: '模板名称',
      dataIndex: 'templateName',
      key: 'templateName',
    },
    {
      title: '模板类型',
      dataIndex: 'templateType',
      key: 'templateType',
    },
    {
      title: '流量额度',
      dataIndex: 'dataAmount',
      key: 'dataAmount',
      render: (amount: number) => `${amount}GB`,
    },
    {
      title: '有效期',
      dataIndex: 'duration',
      key: 'duration',
      render: (duration: number) => `${duration}天`,
    },
    {
      title: '价格',
      dataIndex: 'price',
      key: 'price',
      render: (price: number) => `¥${price}`,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        const statusMap = {
          active: { text: '启用', color: 'green' },
          inactive: { text: '停用', color: 'red' },
        };
        const statusInfo = statusMap[status as keyof typeof statusMap];
        return <Tag color={statusInfo.color}>{statusInfo.text}</Tag>;
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
    },
    {
      title: '操作',
      key: 'action',
      render: (record: PackageTemplate) => (
        <Space size="middle">
          <Button type="link" size="small">查看</Button>
          <Button type="link" size="small">编辑</Button>
          <Button type="link" size="small" icon={<CopyOutlined />}>复制</Button>
          <Button type="link" size="small" danger>删除</Button>
        </Space>
      ),
    },
  ];

  const handleSearch = (value: string) => {
    console.log('搜索:', value);
  };

  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <div>
      <Card>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <Title level={3}>套餐模板</Title>
          </Col>
          <Col>
            <Space>
              <Button icon={<PlusOutlined />} type="primary">
                新增模板
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleRefresh}>
                刷新
              </Button>
            </Space>
          </Col>
        </Row>

        <Row justify="space-between" style={{ marginBottom: 16 }}>
          <Col>
            <Space>
              <Search
                placeholder="搜索模板名称"
                allowClear
                enterButton={<SearchOutlined />}
                style={{ width: 300 }}
                onSearch={handleSearch}
              />
              <Select placeholder="模板类型" style={{ width: 120 }} allowClear>
                <Option value="traffic">流量包</Option>
                <Option value="line">专线</Option>
                <Option value="test">测试</Option>
              </Select>
              <Select placeholder="状态" style={{ width: 120 }} allowClear>
                <Option value="active">启用</Option>
                <Option value="inactive">停用</Option>
              </Select>
            </Space>
          </Col>
          <Col>
            <Space>
              <Button>批量操作</Button>
              <Button>导出数据</Button>
            </Space>
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={mockData}
          loading={loading}
          pagination={{
            total: mockData.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
          }}
        />
      </Card>
    </div>
  );
};

export default PackageTemplate; 